import { StorageServiceKeysMap } from '@core/storage/types/storage.types';
import type { DxRedactionPolicies } from '@kerberos-compliance/compliance-shared-ui/dx';
import { DxRedactionPolicyMap } from '@kerberos-compliance/compliance-shared-ui/dx';

export const dxStorageRedactionPolicies: DxRedactionPolicies = {
  [StorageServiceKeysMap.RedirectUrl]: DxRedactionPolicyMap.Scalar,
  [StorageServiceKeysMap.ShowMaintenanceNotice]: DxRedactionPolicyMap.Scalar,
  [StorageServiceKeysMap.KycTabIndex]: DxRedactionPolicyMap.Scalar,
  [StorageServiceKeysMap.AuthorizationKey]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.WorkItemTypes]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.Industries]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.Organizations]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.InternalUsers]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.Users]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.KycWorkItemList]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.WorkItemCommunicationDrafts]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.DeliveryTrackerList]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.DeliveryTrackerDetailPeriods]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.EmailNotificationList]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.KycFilterState]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.OrganizationFilterState]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.UserFilterState]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.TrainingFilterState]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.DeliveryTrackerFilterState]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.EmailNotificationFilterState]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.UserSortState]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.OrganizationSortState]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.DeliveryTrackerSortState]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.EmailNotificationSortState]: DxRedactionPolicyMap.Shape,
  [StorageServiceKeysMap.AuthenticationStorageKey]: DxRedactionPolicyMap.Presence,
  [StorageServiceKeysMap.UserProfile]: DxRedactionPolicyMap.Presence,
};

export const dxStorageResetGroups = [
  {
    id: 'auth',
    label: 'Clear auth storage',
    keys: [StorageServiceKeysMap.AuthenticationStorageKey, StorageServiceKeysMap.AuthorizationKey],
    consequence: 'Logs this session out: clears the authentication state and the cached grants.',
  },
] as const;
